import React, { useState } from "react";
import { Input } from "../../components/ui/input";
import { FacebookIcon } from "lucide-react";
import SignInModal from "./SignInModal";
import SignUpModal from "./SignUpModal";
function Signin({ onClose }) {
  const [modal, setModal] = useState("signin"); // 'signin', 'signup' or null

  const closeModal = () => setModal(null);
  const openSignIn = () => setModal("signin");
  const openSignUp = () => setModal("signup");
  return (
    <>
      {modal === "signin" && (
        <SignInModal onClose={closeModal} onSignUp={openSignUp} />
      )}

      {modal === "signup" && (
        <SignUpModal onClose={closeModal} onSignIn={openSignIn} />
      )}
    </>
  );
}
export default Signin;
